import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import GoodsInfo from 'view/goodsInfo';

const GoodsManagePage = () => {
	return (
		<PageTemplate>
			<GoodsInfo /> 
		</PageTemplate>
	);
};

export default GoodsManagePage;

 